import React, { memo, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ADMISSION_COLORS as C } from "../constants/admissionTheme";

function SectionAccordion({
  id,
  title,
  children,
  defaultExpanded = true,
  hasError = false,
}) {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const showHighlight = hasError && !expanded;

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
      disableGutters
      elevation={0}
      sx={{
        border: `1px solid ${showHighlight ? C.error.border : C.border}`,
        borderRadius: "8px !important",
        mb: 1.5,
        bgcolor: C.cardBg,
        boxShadow: showHighlight ? `0 0 0 1px ${C.error.border}` : C.shadow.card,
        "&:before": { display: "none" },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: showHighlight ? C.error.text : C.textSecondary }} />}
        aria-controls={`${id}-content`}
        id={`${id}-header`}
        sx={{
          px: 2,
          minHeight: 48,
          bgcolor: showHighlight ? C.error.bg : C.panelHeaderBg,
          borderRadius: "8px",
          "&.Mui-expanded": { minHeight: 48 },
        }}
      >
        <Typography
          variant="subtitle2"
          fontWeight={600}
          color={showHighlight ? C.error.text : C.textPrimary}
        >
          {title}
          {showHighlight && " — required fields missing"}
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ px: 2, pb: 2, pt: 1, bgcolor: C.cardBg }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
}

export default memo(SectionAccordion);
